import { BuildProcess } from '@App/app/entities/processing/build-process.model';

export const sortByProgress = (_: unknown, __: unknown, a: BuildProcess, b: BuildProcess) => {
  return a.compareByProgress(b);
};
